'use client';
import React from 'react';

import { useTriviaRumbleCost } from '@wwe-portal/web/providers/queries/trivia-rumble';
import { IcoMoonIcon } from '../../../../../packages/ui/components/icons';
import { useGetCurrentUser } from '@wwe-portal/web/providers/queries/user-info';
import { useTranslations } from 'next-intl';
import { Button } from '../../../../../packages/ui/components/button';
import Link from 'next/link';
import { useGameStatus } from '@wwe-portal/web/providers/stores/trivia-store';
import { useStartGameMutation } from '@wwe-portal/web/providers/queries/trivia-rumble.mutation';

export const PlayTriviaTrigger = () => {
  const t = useTranslations();
  const { data: triviaRumbleCost } = useTriviaRumbleCost();
  const currentUser = useGetCurrentUser();
  const gameStatus = useGameStatus();

  const { mutate: startGameMutate, isPending } = useStartGameMutation();

  if (!triviaRumbleCost || !currentUser) return null;
  const currentUserEnergy = currentUser.energy;
  const energyCost = triviaRumbleCost.data.data.energyCost;
  const reward = triviaRumbleCost.data.data.reward;
  const handleClick = async () => {
    startGameMutate();
  };
  return (
    <div className="flex flex-col items-center justify-center gap-5">
      <div className="mt-12 flex items-center justify-center text-sm">
        <IcoMoonIcon
          iconName="web-coin-circle"
          className="text-deepSkyBlue text-md mr-[5px]"
          style={{ width: 14, height: 14 }}
        />
        <span className="capitalize">
          {t('win')} {reward} {t('web_coins')}!
        </span>
      </div>
      {currentUserEnergy && currentUserEnergy >= energyCost ? (
        <Button
          disabled={gameStatus !== 'idle'}
          onClick={handleClick}
          variant="blue"
          className="flex h-[46px] w-auto items-center px-9 py-[14px]"
          loading={isPending}
          loadingText={
            <span className="text-sm uppercase">{t('processing')}</span>
          }
          data-id={
            currentUser && currentUserEnergy && currentUserEnergy >= energyCost
              ? 'trivia_game_home_page_play_game'
              : 'trivia_game_home_page_more_energy'
          }
        >
          <div className="flex items-center gap-1">
            <IcoMoonIcon iconName="gamepad" className="size-5" />
            <span className="text-sm uppercase">{t('play_trivia')}</span>
          </div>
        </Button>
      ) : (
        <Link href="/web-coin-shop?category=energyPacks">
          <Button
            className="flex h-[46px] w-auto items-center px-4 py-[14px]"
            variant="blue"
          >
            <div className="flex items-center gap-1">
              <IcoMoonIcon iconName="battery-low" className="size-5" />
              <span className="uppercase">{t('get_more_energy')}</span>
            </div>
          </Button>
        </Link>
      )}

      <div className="text-text600 flex items-center justify-center text-center text-sm">
        <IcoMoonIcon
          iconName="battery-charging"
          className="text-yellow800 mr-1 align-middle"
          style={{ width: 16, height: 16 }}
        />
        {t('cost')} :{' '}
        <span className="text-text300 ml-2">
          {energyCost} {t('energy')}
        </span>
      </div>
    </div>
  );
};
